module.exports = __webpack_public_path__ + "static/media/check.90deb06e.svg";